import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';

import { InsuranceCertificateForm } from './insurance-certificate-form';

export class InsuranceAgentForm {
  constructor() {}

  id = new FormControl<number | undefined>(
    { value: undefined, disabled: false },
    { nonNullable: true }
  );
  VendorId = new FormControl<number | undefined>(
    { value: undefined, disabled: false },
    { nonNullable: true, validators: [Validators.required] }
  );
  email = new FormControl<string | null>(null, {
    validators: [Validators.required]
  });
  agencyName = new FormControl<string | null>(null, {
    validators: [Validators.required]
  });
  firstName = new FormControl<string | null>(null, {
    validators: [Validators.required]
  });
  lastName = new FormControl<string | null>(null, {
    validators: [Validators.required]
  });
  jobTitle = new FormControl<string | null>(null);
  phone1 = new FormControl<string | null>(null, {
    validators: [Validators.required]
  });
  phone1Ext = new FormControl<string | null>(null);
  phone2 = new FormControl<string | null>(null);
  phone2Ext = new FormControl<string | null>(null);
  mayContact = new FormControl<boolean | null>(null);
  isGLProvider = new FormControl<boolean>(false, {
    nonNullable: true,
    validators: [Validators.required]
  });
  isAutoProvider = new FormControl<boolean>(false, {
    nonNullable: true,
    validators: [Validators.required]
  });
  isUmbrellaProvider = new FormControl<boolean>(false, {
    nonNullable: true,
    validators: [Validators.required]
  });
  isWorkersProvider = new FormControl<boolean>(false, {
    nonNullable: true,
    validators: [Validators.required]
  });
  isProfessionalProvider = new FormControl<boolean>(false, {
    nonNullable: true,
    validators: [Validators.required]
  });
  isArchived = new FormControl<boolean>(false, {
    nonNullable: true,
    validators: [Validators.required]
  });

  InsuranceCertificates?: FormArray<InsuranceCertificateForm>;
}
